import React from 'react';

export default function Skeleton() {
	return (
		<div className="p-4 space-y-4">
			<div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-3/4"></div>
			<div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
			<div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-5/6"></div>
		</div>
	);
}
